<template>
  <div id="select_orang">
    <el-select ref="mySelect" v-model="currentValue"
               v-bind="$attrs"
               :remote-method="getOrgan"
               :loading="loading"
               filterable
               clearable remote reserve-keyword style="width: 100%;" :placeholder="placeholder" @change="change" @clear="clearShop">
      <el-option v-for="(item,index) in organList" :key="index" :label="`${item.name}（商户名称:${item.merchantName} shopId:${item.id}）`" :value="item.id"  v-if="isShowShopId"/>
      <el-option v-for="(item,index) in organList" :key="index" :label="item.name" :value="item.id"  v-if="!isShowShopId"/>
    </el-select>
  </div>
</template>

<script>
import { queryAllShop } from "@/api/query";
export default {
  name: "OrgSelect",
  props: {
    defaultValue: {
      type: [String, Number],
      default: ""
    },
    isShowShopId:{
      type: Boolean,
      default: true
    },
    isMain:{
      type: [String, Boolean],
      default: ""
    },
    placeholder:{
      type:String,
      default:'请输入商户名称'
    }
  },
  watch:{
    defaultValue:{
      handler(n){
        this.currentValue=n
        let data = {
          id:n,
          status: 2,
          isMain:this.isMain
        }
        queryAllShop(data).then(d => {
          if (d.code == 0) {
            this.organList = d.data
          } else {
            this.organList = [];
          }
        });
      },
      deep:true
    }
  },
  data() {
    return {
      shopId: "",
      organList: [],
      loading: false,
      currentValue: this.defaultValue
    };
  },
  methods: {
    // 获取商户
    getOrgan(name) {
      if (name) {
        this.loading = true;
        const data = {
          name,
          status: 2,
          isMain:this.isMain
        };
        queryAllShop(data).then(d => {
          console.log(data);
          this.loading = false;
          if (d.code == 0) {
            this.organList = d.data;
          } else {
            this.organList = [];
          }
        });
      }
    },
    change() {
      let found=this.currentValue&& this.organList.find( item =>{
        return item.id ==this.currentValue
      })
      let name= found ? found.name:''
      this.$emit("getVal", this.currentValue,name);
      // this.$emit("getVal", this.currentValue);
    },

    clearShop(e){
      this.currentValue='';
      this.organList = [];

    },
    reset() {
      this.organList = [];
      this.currentValue = "";
    }
  }
};
</script>
<style lang="scss" scoped>
#select_orang {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/Selectorg/index.vue